import * as types from "../../actions/ActionTypes";

const initialState = {
  loading: false,
  plans: [],
  error: null,
};

const getSubscriptionPlansReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.GET_SUBSCRIPTION_PLANS_START:
      return { ...state, loading: true, error: null };
    case types.GET_SUBSCRIPTION_PLANS_SUCCESS:
      return { ...state, loading: false, plans: action.payload };
    case types.GET_SUBSCRIPTION_PLANS_ERROR:
      return { ...state, loading: false, error: action.payload };
    default:
      return state;
  }
};

export default getSubscriptionPlansReducer;
